import { ScenariosMembersListLookupData } from '../../../shared/queries/scenarios';

const CountryCellRenderer = ({ context, value }: {
  context: ScenariosMembersListLookupData,
  value: keyof ScenariosMembersListLookupData['countriesByCode']
}) => context.countriesByCode[value]?.countryDescription || '';


export default CountryCellRenderer;
